export const APP_TAB_PROMOTION_NAV_TAB_OPTIONS = [
    { value: 'contest', label: '대회' },
    { value: 'home', label: '홈' },
    { value: 'benefit', label: '혜택' },
    { value: 'we', label: '우리끼리' },
    { value: 'profile', label: '프로필' },
]

export const APP_TAB_PROMOTION_PLACEMENT_OPTIONS = [
    { value: 'tab_enter_modal', label: '탭 진입 모달' },
]

export const APP_TAB_PROMOTION_ROUTE_TARGET_OPTIONS = [
    { value: '', label: '없음' },
    { value: 'distance_medal_dialog', label: '거리 메달 다이얼로그' },
    { value: 'account_suspension_dialog', label: '계정 정지 다이얼로그' },
    { value: 'animal_contest_detail', label: '애니멀런 상세' },
    { value: 'home', label: '홈' },
    { value: 'meet_we_request_list', label: '우리끼리 요청 목록' },
    { value: 'meet_we_detail', label: '우리끼리 상세' },
    { value: 'private_chat_room', label: '개인 채팅방' },
    { value: 'group_chat_room', label: '그룹 채팅방' },
    { value: 'meet_we_gps_detail', label: '우리끼리 GPS 상세' },
    { value: 'meet_we_qr_detail', label: '우리끼리 QR 상세' },
    { value: 'meet_we_pedometer_detail', label: '우리끼리 만보기 상세' },
    { value: 'meet_we_pedometer_team_detail', label: '우리끼리 팀 만보기 상세' },
    { value: 'attendance_check', label: '출석체크' },
    { value: 'company_community_post', label: '기업 커뮤니티 글' },
    { value: 'company_info', label: '기업 정보' },
    { value: 'company_challenge', label: '기업 챌린지' },
    { value: 'pedometer_ranking', label: '만보기 랭킹' },
    { value: 'pedometer_medal_dialog', label: '만보기 메달 다이얼로그' },
    { value: 'membership', label: '멤버십' },
    { value: 'membership_coupon', label: '멤버십 쿠폰' },
    { value: 'territory_my_tab', label: '땅따먹기 내 탭' },
]

export const APP_TAB_PROMOTION_TARGET_MEMBERSHIP_OPTIONS = [
    { value: 'all', label: '전체' },
    { value: 'non_entitled', label: '미가입/만료' },
    { value: 'entitled', label: '가입중' },
]

export const APP_TAB_PROMOTION_DEVICE_TYPE_OPTIONS = [
    { value: 'all', label: '전체' },
    { value: 'and', label: 'Android' },
    { value: 'ios', label: 'iOS' },
]

export const APP_TAB_PROMOTION_STATUS_OPTIONS = [
    { value: 1, label: '노출' },
    { value: 0, label: '미노출' },
]

export const getAppTabPromotionOptionLabel = (options, value) => {
    const option = options.find(row => String(row.value) === String(value))
    return option?.label || value || '-'
}
